export class OnlinePaymentModule {
    constructor() {
        this.init();
    }
    
    init() {

        $(".toggle-tt").on("click", function () {
            $(".tooltip").removeClass('fade in active');
            $(this).parent('li').find(".tooltip").toggleClass('fade in active');

        });

        $('[id^="close"]').on('click', function () {
            $(this).parent(".tooltip").removeClass('fade in active');
        });

    }
}






